import Account from "./Account";
import Admin from "./Admin";
import Domain from "./Domain";
import Offers from "./Offers";

export default {
  Account: {
    GET: Account.GET,
    POST: Account.POST,
    PUT: Account.PUT,
    DELETE: Account.DELETE,
    PATCH: Account.PATCH,
  },
  Admin: {
    GET: Admin.GET,
    POST: Admin.POST,
    PUT: Admin.PUT,
    DELETE: Admin.DELETE,
    PATCH: Admin.PATCH,
  },
  Domain: {
    GET: Domain.GET,
    POST: Domain.POST,
    PUT: Domain.PUT,
    DELETE: Domain.DELETE,
    PATCH: Domain.PATCH,
  },
  Offers: {
    GET: Offers.GET,
    POST: Offers.POST,
    PUT: Offers.PUT,
    DELETE: Offers.DELETE,
    PATCH: Offers.PATCH,
  },
};
